import Const from 'constants';

let ProjectionPointsType = {
    setProjectionPointsTypeFromStorage(value) {
        return (dispatch) => {
            dispatch(this.setProjectionPointsType(value, {saveToStorage: false}));
        };
    },

    setProjectionPointsType(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_PROJECTION_POINTS_TYPE,
                value,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('projectionPointsType', function (state) {
                    const {projectionPointsType} = state;
                    return projectionPointsType.getProjectionPointsType();
                }),
            );
        };
    },
};

export default ProjectionPointsType;
